"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getIconColor = function getIconColor(_ref) {
  var theme = _ref.theme,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isHovered = _ref.isHovered,
    isIndeterminate = _ref.isIndeterminate;
  switch (true) {
    case isDisabled:
      {
        return theme.disabledColor;
      }
    case isHovered:
      {
        return theme.checkboxIconColorHover;
      }
    case isChecked:
    case isIndeterminate:
      {
        return theme.checkedBackgroundColor;
      }
    case isFocused:
      {
        return theme.backgroundColor || theme.accentColor;
      }
    default:
      {
        return theme.backgroundColor || theme.accentColor;
      }
  }
};
var _default = getIconColor;
exports["default"] = _default;